export default "/images/card-text.svg?b73260c8e5f6dfe8c358334489b16a73";